import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTheme } from '@mui/material';
import {
  useGetMembershipTiersBySpaceQuery,
  useGetPublicSpaceQuery,
} from '../../app/smorgAppSyncGraphQLApi';
import { useGetCurrentSpaceMembershipQuery } from '../../app/smorgAppSyncGraphQLApiCustomHooks';
import { SPACE_REFRESH_INTERVAL_SECONDS } from '../../services/end_user_published_resources';

const AlreadyAMemberButton = ({ spaceID }) => {
  const { data: currentSpace } = useGetPublicSpaceQuery(spaceID, {
    skip: !spaceID,
    refetchOnMountOrArgChange: SPACE_REFRESH_INTERVAL_SECONDS,
  });

  const theme = useTheme();

  const { data: currentSpaceMembership } = useGetCurrentSpaceMembershipQuery();

  const { data: membershipTiers } = useGetMembershipTiersBySpaceQuery(spaceID, {
    skip: !spaceID,
  });

  const membershipTier = (membershipTiers || []).find(
    (mt) => mt.id === currentSpaceMembership?.membershipTierID,
  );

  if (currentSpaceMembership?.spaceID !== spaceID) {
    return 'You are already a member of a different App';
  }

  if (!membershipTier) {
    // Should never happen, if no membership tier is assigned then the Join button should show.
    return null;
  }
  return (
    <div
      className="available-subscription"
      style={{ backgroundColor: theme.palette.primary.cardBackground }}>
      <div>You are already a member of {currentSpace.title}</div>
      <div className="subscription-name">{membershipTier.title}</div>
      <div className="subscribe-action">
        <Link to="/" className="subscribe-action-text">
          Go to app
        </Link>
      </div>
    </div>
  );
};

AlreadyAMemberButton.propTypes = {
  spaceID: PropTypes.string.isRequired,
};

export default AlreadyAMemberButton;
